export enum PassengersTypeEnum {
  ADULT = 'adult',
  CHILD = 'child',
  INFANT = 'infant_without_seat',
}
